/* ==========================================================================
   LOYAL · THE TYPED LINE
   Sentence by sentence, on first entry, once.

   PROGRESSIVE ENHANCEMENT IS THE WHOLE STRUCTURE, not a fallback bolted on.
   The markup ships every character visible. This script's FIRST act is to set
   data-typed, which is what hides them, and only then does it type. If the
   script never loads, never parses, or throws, the reader still gets three
   plain sentences. Nothing here can subtract content.

   IT RUNS ONCE. A line that retypes every time it scrolls back into view stops
   being a statement and becomes an animation, and the second viewing is always
   slower to read than just reading it.

   TIMING IS LINEAR BY CONSTRUCTION. Each character is a fixed step, so there
   is no curve in here to argue with MOTION-SYSTEM's three. The only pause is
   between sentences, at --dwell-2, 300ms.
   ========================================================================== */
(function () {
  'use strict';

  var CHAR_MS = 26;    // per character. 26 lands a sentence just under a second.
  var DWELL_MS = 300;  // --dwell-2, the pause you notice.

  function reduced() {
    return window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function split(root) {
    // Wrap every character of every line. Done in JS rather than Liquid so the
    // no-script DOM stays plain text a screen reader reads as a sentence
    // instead of as a hundred one-letter elements.
    var lines = root.querySelectorAll('.loyal-typed__line');
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var text = line.textContent;
      line.textContent = '';
      // The accessible name lives on the LINE, not on the characters, so the
      // sentence is announced once and whole.
      line.setAttribute('aria-label', text);
      var frag = document.createDocumentFragment();
      for (var c = 0; c < text.length; c++) {
        var span = document.createElement('span');
        span.className = 'loyal-typed__char';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = text[c];
        frag.appendChild(span);
      }
      var caret = document.createElement('span');
      caret.className = 'loyal-typed__caret';
      caret.setAttribute('aria-hidden', 'true');
      frag.appendChild(caret);
      line.appendChild(frag);
    }
    return lines;
  }

  function type(root, lines) {
    var li = 0;

    function nextLine() {
      if (li >= lines.length) {
        root.setAttribute('data-typed', 'done');
        return;
      }
      var line = lines[li];
      var chars = line.querySelectorAll('.loyal-typed__char');
      line.setAttribute('data-active', '');
      var ci = 0;
      var last = 0;

      function step(now) {
        if (!last) last = now;
        // Catch up rather than drop characters if a frame is late. A dropped
        // character reads as a typo, which is the one thing this must not do.
        while (now - last >= CHAR_MS && ci < chars.length) {
          chars[ci].setAttribute('data-on', '');
          ci++;
          last += CHAR_MS;
        }
        if (ci < chars.length) {
          requestAnimationFrame(step);
        } else {
          line.removeAttribute('data-active');
          li++;
          setTimeout(nextLine, DWELL_MS);
        }
      }
      requestAnimationFrame(step);
    }

    nextLine();
  }

  function init(root) {
    var lines = split(root);

    // PIN THE HEIGHT BEFORE HIDING ANYTHING. Characters are hidden with
    // display:none so the caret can sit against the last one typed, which means
    // the block grows as it fills. Measured at full height first and pinned, so
    // the growth happens inside a box that never changes size and nothing below
    // this section moves while it types.
    root.style.minHeight = root.getBoundingClientRect().height + 'px';

    if (reduced()) {
      // Show everything. data-typed still goes on so the CSS reduced-motion
      // block, which forces the characters visible, has something to match.
      root.setAttribute('data-typed', 'done');
      return;
    }

    root.setAttribute('data-typed', '');

    if (!('IntersectionObserver' in window)) {
      type(root, lines);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          io.disconnect();
          type(root, lines);
        }
      }
    }, { threshold: 0.5 });
    io.observe(root);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-loyal-typed]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
